import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Adds a `mat-<color>` CSS class to the host element.
 * This replaces the legacy `mixinColor` behavior that was removed in MDC components.
 * MDC components only support 'primary', 'accent', and 'warn' via the `color` input.
 * Use this directive for custom palette names like 'secondary', 'secondary-invert', etc.
 */
@Directive({
  selector: '[mcColor]'
})
export class McColorDirective implements OnChanges {
  @Input() mcColor: string;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['mcColor']) {
      const prev = changes['mcColor'].previousValue;
      if (prev) {
        this.elementRef.nativeElement.classList.remove(`mat-${prev}`);
      }
      if (this.mcColor) {
        this.elementRef.nativeElement.classList.add(`mat-${this.mcColor}`);
      }
    }
  }
}
